"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The RegistrationDetails model module.
 * @module model/RegistrationDetails
 * @version 3.0
 */
var RegistrationDetails = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>RegistrationDetails</code>.
   * @alias module:model/RegistrationDetails
   * @param operatorCode {String} 
   * @param primaryIdentifier {String} 
   * @param primaryIdentifierType {module:model/RegistrationDetails.PrimaryIdentifierTypeEnum} 
   * @param username {String} 
   * @param title {String} 
   * @param firstName {String} 
   * @param lastName {String} 
   * @param dob {Date} 
   * @param emailAddress {String} 
   */
  function RegistrationDetails(operatorCode, primaryIdentifier, primaryIdentifierType, username, title, firstName, lastName, dob, emailAddress) {
    _classCallCheck(this, RegistrationDetails);
    RegistrationDetails.initialize(this, operatorCode, primaryIdentifier, primaryIdentifierType, username, title, firstName, lastName, dob, emailAddress);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(RegistrationDetails, null, [{
    key: "initialize",
    value: function initialize(obj, operatorCode, primaryIdentifier, primaryIdentifierType, username, title, firstName, lastName, dob, emailAddress) {
      obj['operatorCode'] = operatorCode;
      obj['primaryIdentifier'] = primaryIdentifier;
      obj['primaryIdentifierType'] = primaryIdentifierType;
      obj['username'] = username;
      obj['title'] = title;
      obj['firstName'] = firstName;
      obj['lastName'] = lastName;
      obj['dob'] = dob;
      obj['emailAddress'] = emailAddress;
    }

    /**
     * Constructs a <code>RegistrationDetails</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RegistrationDetails} obj Optional instance to populate.
     * @return {module:model/RegistrationDetails} The populated <code>RegistrationDetails</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new RegistrationDetails();
        if (data.hasOwnProperty('operatorCode')) {
          obj['operatorCode'] = _ApiClient["default"].convertToType(data['operatorCode'], 'String');
        }
        if (data.hasOwnProperty('primaryIdentifier')) {
          obj['primaryIdentifier'] = _ApiClient["default"].convertToType(data['primaryIdentifier'], 'String');
        }
        if (data.hasOwnProperty('primaryIdentifierType')) {
          obj['primaryIdentifierType'] = _ApiClient["default"].convertToType(data['primaryIdentifierType'], 'String');
        }
        if (data.hasOwnProperty('username')) {
          obj['username'] = _ApiClient["default"].convertToType(data['username'], 'String');
        }
        if (data.hasOwnProperty('title')) {
          obj['title'] = _ApiClient["default"].convertToType(data['title'], 'String');
        }
        if (data.hasOwnProperty('firstName')) {
          obj['firstName'] = _ApiClient["default"].convertToType(data['firstName'], 'String');
        }
        if (data.hasOwnProperty('middleName')) {
          obj['middleName'] = _ApiClient["default"].convertToType(data['middleName'], 'String');
        }
        if (data.hasOwnProperty('lastName')) {
          obj['lastName'] = _ApiClient["default"].convertToType(data['lastName'], 'String');
        }
        if (data.hasOwnProperty('dob')) {
          obj['dob'] = _ApiClient["default"].convertToType(data['dob'], 'Date');
        }
        if (data.hasOwnProperty('gender')) {
          obj['gender'] = _ApiClient["default"].convertToType(data['gender'], 'String');
        }
        if (data.hasOwnProperty('emailAddress')) {
          obj['emailAddress'] = _ApiClient["default"].convertToType(data['emailAddress'], 'String');
        }
        if (data.hasOwnProperty('primaryContactNumber')) {
          obj['primaryContactNumber'] = _ApiClient["default"].convertToType(data['primaryContactNumber'], 'String');
        }
        if (data.hasOwnProperty('primaryContactNumberCountryCode')) {
          obj['primaryContactNumberCountryCode'] = _ApiClient["default"].convertToType(data['primaryContactNumberCountryCode'], 'String');
        }
        if (data.hasOwnProperty('nationality')) {
          obj['nationality'] = _ApiClient["default"].convertToType(data['nationality'], 'String');
        }
        if (data.hasOwnProperty('countryOfResidence')) {
          obj['countryOfResidence'] = _ApiClient["default"].convertToType(data['countryOfResidence'], 'String');
        }
        if (data.hasOwnProperty('nickname')) {
          obj['nickname'] = _ApiClient["default"].convertToType(data['nickname'], 'String');
        }
        if (data.hasOwnProperty('identificationType')) {
          obj['identificationType'] = _ApiClient["default"].convertToType(data['identificationType'], 'String');
        }
        if (data.hasOwnProperty('identificationNumber')) {
          obj['identificationNumber'] = _ApiClient["default"].convertToType(data['identificationNumber'], 'String');
        }
        if (data.hasOwnProperty('identificationValidFrom')) {
          obj['identificationValidFrom'] = _ApiClient["default"].convertToType(data['identificationValidFrom'], 'Date');
        }
        if (data.hasOwnProperty('identificationValidTo')) {
          obj['identificationValidTo'] = _ApiClient["default"].convertToType(data['identificationValidTo'], 'Date');
        }
        if (data.hasOwnProperty('twoFactorAuthNumber')) {
          obj['twoFactorAuthNumber'] = _ApiClient["default"].convertToType(data['twoFactorAuthNumber'], 'String');
        }
        if (data.hasOwnProperty('twoFactorAuthNumberCountryCode')) {
          obj['twoFactorAuthNumberCountryCode'] = _ApiClient["default"].convertToType(data['twoFactorAuthNumberCountryCode'], 'String');
        }
        if (data.hasOwnProperty('smsCommunciationNumber')) {
          obj['smsCommunciationNumber'] = _ApiClient["default"].convertToType(data['smsCommunciationNumber'], 'String');
        }
        if (data.hasOwnProperty('smsCommunciationNumberCountryCode')) {
          obj['smsCommunciationNumberCountryCode'] = _ApiClient["default"].convertToType(data['smsCommunciationNumberCountryCode'], 'String');
        }
        if (data.hasOwnProperty('taxCode')) {
          obj['taxCode'] = _ApiClient["default"].convertToType(data['taxCode'], 'String');
        }
        if (data.hasOwnProperty('guest')) {
          obj['guest'] = _ApiClient["default"].convertToType(data['guest'], 'Boolean');
        }
        if (data.hasOwnProperty('otpCode')) {
          obj['otpCode'] = _ApiClient["default"].convertToType(data['otpCode'], 'String');
        }
        if (data.hasOwnProperty('password')) {
          obj['password'] = _ApiClient["default"].convertToType(data['password'], 'String');
        }
        if (data.hasOwnProperty('mockOtpSend')) {
          obj['mockOtpSend'] = _ApiClient["default"].convertToType(data['mockOtpSend'], 'Boolean');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>RegistrationDetails</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RegistrationDetails</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(RegistrationDetails.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data.hasOwnProperty(property)) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['operatorCode'] && !(typeof data['operatorCode'] === 'string' || data['operatorCode'] instanceof String)) {
        throw new Error("Expected the field `operatorCode` to be a primitive type in the JSON string but got " + data['operatorCode']);
      }
      // ensure the json data is a string
      if (data['primaryIdentifier'] && !(typeof data['primaryIdentifier'] === 'string' || data['primaryIdentifier'] instanceof String)) {
        throw new Error("Expected the field `primaryIdentifier` to be a primitive type in the JSON string but got " + data['primaryIdentifier']);
      }
      // ensure the json data is a string
      if (data['primaryIdentifierType'] && !(typeof data['primaryIdentifierType'] === 'string' || data['primaryIdentifierType'] instanceof String)) {
        throw new Error("Expected the field `primaryIdentifierType` to be a primitive type in the JSON string but got " + data['primaryIdentifierType']);
      }
      // ensure the json data is a string
      if (data['username'] && !(typeof data['username'] === 'string' || data['username'] instanceof String)) {
        throw new Error("Expected the field `username` to be a primitive type in the JSON string but got " + data['username']);
      }
      // ensure the json data is a string
      if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
        throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
      }
      // ensure the json data is a string
      if (data['firstName'] && !(typeof data['firstName'] === 'string' || data['firstName'] instanceof String)) {
        throw new Error("Expected the field `firstName` to be a primitive type in the JSON string but got " + data['firstName']);
      }
      // ensure the json data is a string
      if (data['middleName'] && !(typeof data['middleName'] === 'string' || data['middleName'] instanceof String)) {
        throw new Error("Expected the field `middleName` to be a primitive type in the JSON string but got " + data['middleName']);
      }
      // ensure the json data is a string
      if (data['lastName'] && !(typeof data['lastName'] === 'string' || data['lastName'] instanceof String)) {
        throw new Error("Expected the field `lastName` to be a primitive type in the JSON string but got " + data['lastName']);
      }
      // ensure the json data is a string
      if (data['gender'] && !(typeof data['gender'] === 'string' || data['gender'] instanceof String)) {
        throw new Error("Expected the field `gender` to be a primitive type in the JSON string but got " + data['gender']);
      }
      // ensure the json data is a string
      if (data['emailAddress'] && !(typeof data['emailAddress'] === 'string' || data['emailAddress'] instanceof String)) {
        throw new Error("Expected the field `emailAddress` to be a primitive type in the JSON string but got " + data['emailAddress']);
      }
      // ensure the json data is a string
      if (data['primaryContactNumber'] && !(typeof data['primaryContactNumber'] === 'string' || data['primaryContactNumber'] instanceof String)) {
        throw new Error("Expected the field `primaryContactNumber` to be a primitive type in the JSON string but got " + data['primaryContactNumber']);
      }
      // ensure the json data is a string
      if (data['primaryContactNumberCountryCode'] && !(typeof data['primaryContactNumberCountryCode'] === 'string' || data['primaryContactNumberCountryCode'] instanceof String)) {
        throw new Error("Expected the field `primaryContactNumberCountryCode` to be a primitive type in the JSON string but got " + data['primaryContactNumberCountryCode']);
      }
      // ensure the json data is a string
      if (data['nationality'] && !(typeof data['nationality'] === 'string' || data['nationality'] instanceof String)) {
        throw new Error("Expected the field `nationality` to be a primitive type in the JSON string but got " + data['nationality']);
      }
      // ensure the json data is a string
      if (data['countryOfResidence'] && !(typeof data['countryOfResidence'] === 'string' || data['countryOfResidence'] instanceof String)) {
        throw new Error("Expected the field `countryOfResidence` to be a primitive type in the JSON string but got " + data['countryOfResidence']);
      }
      // ensure the json data is a string
      if (data['nickname'] && !(typeof data['nickname'] === 'string' || data['nickname'] instanceof String)) {
        throw new Error("Expected the field `nickname` to be a primitive type in the JSON string but got " + data['nickname']);
      }
      // ensure the json data is a string
      if (data['identificationType'] && !(typeof data['identificationType'] === 'string' || data['identificationType'] instanceof String)) {
        throw new Error("Expected the field `identificationType` to be a primitive type in the JSON string but got " + data['identificationType']);
      }
      // ensure the json data is a string
      if (data['identificationNumber'] && !(typeof data['identificationNumber'] === 'string' || data['identificationNumber'] instanceof String)) {
        throw new Error("Expected the field `identificationNumber` to be a primitive type in the JSON string but got " + data['identificationNumber']);
      }
      // ensure the json data is a string
      if (data['twoFactorAuthNumber'] && !(typeof data['twoFactorAuthNumber'] === 'string' || data['twoFactorAuthNumber'] instanceof String)) {
        throw new Error("Expected the field `twoFactorAuthNumber` to be a primitive type in the JSON string but got " + data['twoFactorAuthNumber']);
      }
      // ensure the json data is a string
      if (data['twoFactorAuthNumberCountryCode'] && !(typeof data['twoFactorAuthNumberCountryCode'] === 'string' || data['twoFactorAuthNumberCountryCode'] instanceof String)) {
        throw new Error("Expected the field `twoFactorAuthNumberCountryCode` to be a primitive type in the JSON string but got " + data['twoFactorAuthNumberCountryCode']);
      }
      // ensure the json data is a string
      if (data['smsCommunciationNumber'] && !(typeof data['smsCommunciationNumber'] === 'string' || data['smsCommunciationNumber'] instanceof String)) {
        throw new Error("Expected the field `smsCommunciationNumber` to be a primitive type in the JSON string but got " + data['smsCommunciationNumber']);
      }
      // ensure the json data is a string
      if (data['smsCommunciationNumberCountryCode'] && !(typeof data['smsCommunciationNumberCountryCode'] === 'string' || data['smsCommunciationNumberCountryCode'] instanceof String)) {
        throw new Error("Expected the field `smsCommunciationNumberCountryCode` to be a primitive type in the JSON string but got " + data['smsCommunciationNumberCountryCode']);
      }
      // ensure the json data is a string
      if (data['taxCode'] && !(typeof data['taxCode'] === 'string' || data['taxCode'] instanceof String)) {
        throw new Error("Expected the field `taxCode` to be a primitive type in the JSON string but got " + data['taxCode']);
      }
      // ensure the json data is a string
      if (data['otpCode'] && !(typeof data['otpCode'] === 'string' || data['otpCode'] instanceof String)) {
        throw new Error("Expected the field `otpCode` to be a primitive type in the JSON string but got " + data['otpCode']);
      }
      // ensure the json data is a string
      if (data['password'] && !(typeof data['password'] === 'string' || data['password'] instanceof String)) {
        throw new Error("Expected the field `password` to be a primitive type in the JSON string but got " + data['password']);
      }
      return true;
    }
  }]);
}();
RegistrationDetails.RequiredProperties = ["operatorCode", "primaryIdentifier", "primaryIdentifierType", "username", "title", "firstName", "lastName", "dob", "emailAddress"];

/**
 * @member {String} operatorCode
 */
RegistrationDetails.prototype['operatorCode'] = undefined;

/**
 * @member {String} primaryIdentifier
 */
RegistrationDetails.prototype['primaryIdentifier'] = undefined;

/**
 * @member {module:model/RegistrationDetails.PrimaryIdentifierTypeEnum} primaryIdentifierType
 */
RegistrationDetails.prototype['primaryIdentifierType'] = undefined;

/**
 * @member {String} username
 */
RegistrationDetails.prototype['username'] = undefined;

/**
 * @member {String} title
 */
RegistrationDetails.prototype['title'] = undefined;

/**
 * @member {String} firstName
 */
RegistrationDetails.prototype['firstName'] = undefined;

/**
 * @member {String} middleName
 */
RegistrationDetails.prototype['middleName'] = undefined;

/**
 * @member {String} lastName
 */
RegistrationDetails.prototype['lastName'] = undefined;

/**
 * @member {Date} dob
 */
RegistrationDetails.prototype['dob'] = undefined;

/**
 * @member {String} gender
 */
RegistrationDetails.prototype['gender'] = undefined;

/**
 * @member {String} emailAddress
 */
RegistrationDetails.prototype['emailAddress'] = undefined;

/**
 * @member {String} primaryContactNumber
 */
RegistrationDetails.prototype['primaryContactNumber'] = undefined;

/**
 * @member {String} primaryContactNumberCountryCode
 */
RegistrationDetails.prototype['primaryContactNumberCountryCode'] = undefined;

/**
 * @member {String} nationality
 */
RegistrationDetails.prototype['nationality'] = undefined;

/**
 * @member {String} countryOfResidence
 */
RegistrationDetails.prototype['countryOfResidence'] = undefined;

/**
 * @member {String} nickname
 */
RegistrationDetails.prototype['nickname'] = undefined;

/**
 * @member {String} identificationType
 */
RegistrationDetails.prototype['identificationType'] = undefined;

/**
 * @member {String} identificationNumber
 */
RegistrationDetails.prototype['identificationNumber'] = undefined;

/**
 * @member {Date} identificationValidFrom
 */
RegistrationDetails.prototype['identificationValidFrom'] = undefined;

/**
 * @member {Date} identificationValidTo
 */
RegistrationDetails.prototype['identificationValidTo'] = undefined;

/**
 * @member {String} twoFactorAuthNumber
 */
RegistrationDetails.prototype['twoFactorAuthNumber'] = undefined;

/**
 * @member {String} twoFactorAuthNumberCountryCode
 */
RegistrationDetails.prototype['twoFactorAuthNumberCountryCode'] = undefined;

/**
 * @member {String} smsCommunciationNumber
 */
RegistrationDetails.prototype['smsCommunciationNumber'] = undefined;

/**
 * @member {String} smsCommunciationNumberCountryCode
 */
RegistrationDetails.prototype['smsCommunciationNumberCountryCode'] = undefined;

/**
 * @member {String} taxCode
 */
RegistrationDetails.prototype['taxCode'] = undefined;

/**
 * @member {Boolean} guest
 */
RegistrationDetails.prototype['guest'] = undefined;

/**
 * @member {String} otpCode
 */
RegistrationDetails.prototype['otpCode'] = undefined;

/**
 * @member {String} password
 */
RegistrationDetails.prototype['password'] = undefined;

/**
 * @member {Boolean} mockOtpSend
 */
RegistrationDetails.prototype['mockOtpSend'] = undefined;

/**
 * Allowed values for the <code>primaryIdentifierType</code> property.
 * @enum {String}
 * @readonly
 */
RegistrationDetails['PrimaryIdentifierTypeEnum'] = {
  /**
   * value: "SERVICE"
   * @const
   */
  "SERVICE": "SERVICE",
  /**
   * value: "ACCOUNT"
   * @const
   */
  "ACCOUNT": "ACCOUNT",
  /**
   * value: "CUSTOMER"
   * @const
   */
  "CUSTOMER": "CUSTOMER"
};
var _default = exports["default"] = RegistrationDetails;